import { render, staticRenderFns } from "./OwnerForm.vue?vue&type=template&id=55a25e6a&"
import script from "./OwnerForm.vue?vue&type=script&lang=js&"
export * from "./OwnerForm.vue?vue&type=script&lang=js&"
import style0 from "./OwnerForm.vue?vue&type=style&index=0&id=55a25e6a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports